import { EngagementSystem } from './engagement-system.model';

export const isDomainLoaded = (state: EngagementSystem) => state.domainLoaded;
